import React, {useState} from "react";
import DatasetSelection from "./DatasetSelection";
import DatasetView from "./DatasetView";
import {Button} from "primereact/button";
import {Dataset} from "./models/types";
import {removeItemById} from "./utils/utils";
import "./styles/style.scss";

const DatasetWindow = () => {
    const [selectedDatasets, setSelectedDatasets] = useState<Array<Dataset>>([]);
    const [selectionPanel, setSelectionPanel] = useState<boolean>(true);
    const removeDataset = (removedId: string) => {
        setSelectedDatasets(removeItemById(selectedDatasets, removedId))
    }
    return <div className="windowSplit">
            {selectionPanel ?
                <Button
                    icon="pi pi-chevron-left"
                    className="toggleButton p-button p-button-text"
                    onClick={() => setSelectionPanel(false)}
                />
                :
                <Button
                    icon="pi pi-chevron-right"
                    className="toggleButton collapsed p-button p-button-text"
                    onClick={() => setSelectionPanel(true)}
                />
            }
            <div style={{display: "inline"}}>
                {selectionPanel &&
                    <div className="datatable  horizontal">
                        <DatasetSelection datasets={selectedDatasets} setDatasets={setSelectedDatasets} useSearchParameters={true}/>
                    </div>
                }
            </div>

            <DatasetView selectedDatasetsID={selectedDatasets} setSelectedDatasets={setSelectedDatasets} removeDataset={removeDataset}/>
        </div>
};

export default DatasetWindow;
